var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.75C4.425 0.75 0.75 4.425 0.75 9C0.75 13.575 4.425 17.25 9 17.25C13.575 17.25 17.25 13.575 17.25 9C17.25 4.425 13.575 0.75 9 0.75ZM9 15.75C5.25 15.75 2.25 12.75 2.25 9C2.25 5.25 5.25 2.25 9 2.25C12.75 2.25 15.75 5.25 15.75 9C15.75 12.75 12.75 15.75 9 15.75ZM10.05 9L11.775 7.275C12.075 6.975 12.075 6.525 11.775 6.225C11.475 5.925 11.025 5.925 10.725 6.225L9 7.95L7.275 6.225C6.975 5.925 6.525 5.925 6.225 6.225C5.925 6.525 5.925 6.975 6.225 7.275L7.95 9L6.225 10.725C5.925 11.025 5.925 11.475 6.225 11.775C6.375 11.925 6.525 12 6.75 12C6.975 12 7.125 11.925 7.275 11.775L9 10.05L10.725 11.775C10.875 11.925 11.025 12 11.25 12C11.475 12 11.625 11.925 11.775 11.775C12.075 11.475 12.075 11.025 11.775 10.725L10.05 9Z",
    fill: "#828282"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3792_38018",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.75C4.425 0.75 0.75 4.425 0.75 9C0.75 13.575 4.425 17.25 9 17.25C13.575 17.25 17.25 13.575 17.25 9C17.25 4.425 13.575 0.75 9 0.75ZM9 15.75C5.25 15.75 2.25 12.75 2.25 9C2.25 5.25 5.25 2.25 9 2.25C12.75 2.25 15.75 5.25 15.75 9C15.75 12.75 12.75 15.75 9 15.75ZM10.05 9L11.775 7.275C12.075 6.975 12.075 6.525 11.775 6.225C11.475 5.925 11.025 5.925 10.725 6.225L9 7.95L7.275 6.225C6.975 5.925 6.525 5.925 6.225 6.225C5.925 6.525 5.925 6.975 6.225 7.275L7.95 9L6.225 10.725C5.925 11.025 5.925 11.475 6.225 11.775C6.375 11.925 6.525 12 6.75 12C6.975 12 7.125 11.925 7.275 11.775L9 10.05L10.725 11.775C10.875 11.925 11.025 12 11.25 12C11.475 12 11.625 11.925 11.775 11.775C12.075 11.475 12.075 11.025 11.775 10.725L10.05 9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3792_38018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H18V18H0V0Z",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormCloseIcon);
export default __webpack_public_path__ + "static/media/FormCloseIcon.b72d775ee4f1f625fa45f5578acaeb18.svg";
export { ForwardRef as ReactComponent };